import Navbar from '@web/Navbar'
import { Outlet } from 'react-router-dom'

export function SolutionsPage() {
  return (
    <>
      <header className="absolute inset-x-0 top-0 z-50 h-32 bg-brand-navy">
        <Navbar />
      </header>
      <main className="pt-32">
        <Outlet />
      </main>
    </>
  )
}
